(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global['js-i18n'] = {}));
}(this, (function (exports) { 'use strict';

  var LangueUtils = /** @class */ (function () {
      /**
       * Crée une instance de LangueUtils.
       *
       * @param {*} fr Tous les libellés français du component.
       * @param {*} en Tous les libellés anglais du component.
       * @memberof LangueUtils
       */
      function LangueUtils(fr, en) {
          this.EN = 'en';
          this.FR = 'fr';
          this.initialiserLanguesDisponibles(fr, en);
      }
      /**
       * Obtenir les libellés selon la langue courante fournie par this.obtenirLangueDocument().
       *
       * @returns Les libellés.
       */
      LangueUtils.prototype.obtenirLibelles = function () {
          var langue = this.obtenirLangueDocument();
          if (this.languesDisponibles.get(langue)) {
              return this.languesDisponibles.get(langue);
          }
      };
      /**
       * Obtenir la langue préalablement définie dans l'attribut lang de la balise html.
       * Si langue autre qu'anglais, on fallback sur le francais.
       *
       * @returns la langue définie dans la balsie html du document ou "fr" si undefined ou null
       */
      LangueUtils.prototype.obtenirLangueDocument = function () {
          if (document.getElementsByTagName("html")[0].getAttribute("lang") === this.EN) {
              return this.EN;
          }
          return this.FR;
      };
      /**
       * Retourner si la langue est français ou non.
       *
       * @param {string} langue La langue courante.
       * @returns {boolean} `true` si la langue est français et `false` sinon.
       */
      LangueUtils.prototype.estLangueFrancais = function (langue) {
          return langue === this.FR;
      };
      /**
       * Retourne la chaine de caractères avec tous les '%s' remplacés par les
       * valeurs fournies dans l'ordre des arguments passés.
       *
       * @param {string} chaine chaine de caractères contenant les '%s' à remplacer
       * @param {string[]} remplacants tableau de string contenant les remplaçants à mettre dans la chaine de caractères(dans l'ordre)
       * @returns {string} la chaine de caractères qui a eu ses valeurs remplacées ou chaine si paramètres invalide
       */
      LangueUtils.prototype.formatString = function (chaine, remplacants) {
          if (chaine && chaine.indexOf('%s') >= 0) {
              remplacants.forEach(function (remplacant) { return chaine = chaine.replace("%s", remplacant); });
          }
          return chaine;
      };
      /**
       * Initialise les langues disponibles dans une Map.
       *
       * @private
       * @param {*} fr Tous les libellés français du component.
       * @param {*} en Tous les libellés anglais du component.
       */
      LangueUtils.prototype.initialiserLanguesDisponibles = function (fr, en) {
          this.languesDisponibles = new Map([
              [this.FR, fr],
              [this.EN, en]
          ]);
      };
      return LangueUtils;
  }());

  exports.LangueUtils = LangueUtils;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
